import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'

interface UnderlineLinkProps {
    href: string
    children: ReactNode
    className?: string
}

/**
 * Small uppercase link with a rule beneath it. On hover the rule slides out to
 * the right while a second rule slides in from the left, as on the original.
 */
export const UnderlineLink: FC<UnderlineLinkProps> = ({
    href,
    children,
    className
}): ReactNode => {
    return (
        <Link
            href={href}
            className={cn(
                'group relative inline-flex flex-col gap-2 text-[16px] font-medium uppercase leading-none tracking-[0.06em]',
                className
            )}
        >
            <span className='whitespace-nowrap'>
                {children}
            </span>

            <span aria-hidden='true' className='relative h-px w-full overflow-hidden'>
                <span className='absolute inset-0 bg-current transition-transform duration-500 ease-out group-hover:translate-x-full' />
                <span className='absolute inset-0 -translate-x-full bg-current transition-transform duration-500 ease-out group-hover:translate-x-0' />
            </span>
        </Link>
    )
}
